import metaContent from '../fn/metaContent';

const urlWithHost = (route, metaName = 'appRoot') => {
  if (route.startsWith('http')) return route;
  const host = metaContent(metaName);
  return `${host}${route}`;
}

export default urlWithHost;
